import BaseUseCase from "../../base_use_case.js.jsx";

import { 
  AvailableAssetsName,
  AvgNetProfitForMonth,
} from "../../../questionnaire_constants.js";

class ShowLimitInvestmentUseCase extends BaseUseCase {

  execute(params) {
    const queryParams = {};
    const { participant: { user: { questionnaire: { data: questions = [] } } } } = params;

    const availableAssets = questions.find(item => item.key === AvailableAssetsName)
    const avgNetProfit = questions.find(item => item.key === AvgNetProfitForMonth)

    if(questions.length > 0 && availableAssets && availableAssets.singleValueKey) {
      queryParams.availableAssets = availableAssets.singleValueKey
    }

    if(questions.length > 0 && avgNetProfit && avgNetProfit.numberValue) {
      queryParams.avgNetProfitForMonth = avgNetProfit.numberValue
    }

    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/projects/investments/limit`,
      params: queryParams
    }).then((result) => {
      return result
    })
  }
}

const instance = new ShowLimitInvestmentUseCase();
export default instance;